import React, { useEffect, useRef } from "react";
import { NeoJumbotron } from "../components/ui/NeoJumbotron";
import NeoPageLayout from "../components/ui/NeoPageLayout";
import { useNavigate } from "react-router-dom";
import hotToast from "react-hot-toast";
import { Validators } from "../utils/validators.utils";
import { useHttpClient } from "../utils/http.utils";
import { Button } from "@chakra-ui/react";

const ContactUsView: React.FC = () => {
    const navigate = useNavigate();
    const contactUsInputRef = useRef<HTMLInputElement>(null);
    const { joinWaitListApi } = useHttpClient();

    useEffect(() => {
        const navbarLinks: HTMLCollectionOf<HTMLUListElement> = document.getElementsByClassName("landing-nav-link") as HTMLCollectionOf<HTMLUListElement>;
        for (let i = 0; i < navbarLinks.length; i++) {
            if (navbarLinks.item(i)) {
                navbarLinks.item(i)!.style.color = "#FFFFFF";
            }
        }
    }, []);

    const onEnterEmail = (e: any) => {

        const input = contactUsInputRef.current,
            inputValue = input!.value;

        if (!inputValue) {
            return;
        }

        const email = inputValue.trim();

        if (!Validators.validateEmail(email)) {
            hotToast.error("Please provide a valid email");
            return;
        }

        let toastId = hotToast.loading("Saving your email");
        // Add to database
        joinWaitListApi({ email: email, platform: "ats_website" })
            .then(({ data }) => {
                if (data["success"] === false) {
                    // If the user is already in the waitlist
                    if (data?.error[0].code === 5902) {
                        hotToast.error("You are already on the list. We will get to you shortly.", {
                            id: toastId,
                        });
                    } else {
                        hotToast.error("Cannot save your email at this time. Please try again later", {
                            id: toastId,
                        });
                    }

                } else {
                    hotToast.success("Your email has been saved. We will get back to you shortly", {
                        id: toastId,
                    });
                    // clear input
                    input!.value = "";
                }
            })
            .catch(err => {
                console.error(err?.error)
                hotToast.error("Cannot save your email at this time. Please try again later", {
                    id: toastId,
                });
            })
    }

    return (
        <NeoPageLayout
            pageTitle="Contact Us - ATS Global"
            pageDescription="Complete and Tailored AI Solutions"
            isLoading={false}
            logoUrl={{
                white: "/ATS_Global_Branding_SansNeo_White.png",
                black: "ATS_Global_Branding_SansNeo_Black.png"
            }}
            logoStyle={{
                height: "65px",
            }}
            logoAction={"/"}
            links={[
                {
                    title: "project x",
                    action: "/project-x",
                },
                {
                    title: "about",
                    action: "/about",
                },
                // {
                //     title: "blog",
                //     action: "/blog",
                // },
                {
                    title: "team",
                    action: "/team",
                },
                {
                    title: "contact us",
                    action: "/contact-us",
                    active: true
                },
            ]}
            mobileFooterLinks={[
                {
                    title: "NeoAI",
                    action: "https://neoworlder.ai",
                },
                {
                    title: "NeoWorlder",
                    action: "https://neoworlder.com",
                },
                {
                    title: "Lootverse",
                    action: "https://lootverse.com",
                },
            ]}
        >

            <NeoJumbotron
                id="contactUs"
                theme="dark"
                title={
                    <span>
                       Contact Us
                    </span>
                }
                subtitle={<span>
                    By clicking "Submit" you agree to ATS Global’s Terms of Use and Privacy Policy.
                    You consent to receive emails, phone calls and SMS messages from ATS Global for marketing purposes. 
                    Message frequency depends on your activity. You may opt-out by texting "STOP". <br /> Message and data rates may apply
                </span>}
                backgroundImage="/spiral_bg.png"
                backgroundImageClass="bottom-[0px] md:bottom-[-180px]"
                onNavigate={() => navigate("/")}
                onNavigateBack={() => navigate("/team")}
            >
                <div className="absolute top-[505px] md:top-[380px] w-[90%] md:w-[380px]">

                    <div className="mt-[20px]">
                        <input ref={contactUsInputRef} type="text" className="border cursor-text border-white h-[56px] rounded-[8px] px-[10px] outline-none text-white w-full bg-transparent" placeholder="Email" />
                        <Button style={{color: "#000"}} onClick={onEnterEmail} background={"white"} className="w-full text-black" mt={4} color={"black"}>Submit</Button>
                    </div>
                </div>
            </NeoJumbotron>
        </NeoPageLayout>
    )
}

export default ContactUsView;